import { StandardForm } from "../../../../../../../../shared/components/forms/StandardForm"
import { StandardMainPanel } from "../../../../../../../../shared/components/forms/StandardMainPanel"
import { NotificationsTable } from "../../room/general/NotificationsTable"

export function FormMobileAVNotificationsContent() {
    return (
        <StandardForm>
            <StandardMainPanel title="Reminders">
                <NotificationsTable />
            </StandardMainPanel>
        </StandardForm>
    )
}
